import { messaging, getToken, onMessage } from "./firebase";

export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BJbCeJRFVQl9UYWYvyv2puUa5wrPIXNiurJ_psjiRvIMjOFeokZJad-ipQ5UbZduaE5N1D5HhE8MFsSZad6MA8A", // Get from Firebase → Project Settings → Cloud Messaging
    });
    if (currentToken) {
      console.log("FCM token", currentToken);
      return currentToken;
    } else {
      console.warn("No registration token available.");
      return null;
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      resolve(payload);
    });
  });
